import {
  SEARCH_TEXT,
  SET_FREECOPY_TOKEN,
  SET_GIFT_TOKEN,
  SET_LOCALE,
} from "actions/ActionTypes";

export const setSearchText = (value) => ({
  type: SEARCH_TEXT,
  searchText: value,
});

export const setFreecopyToken = (value) => ({
  type: SET_FREECOPY_TOKEN,
  freecopy_token: value,
});

export const setGiftToken = (value) => ({
  type: SET_GIFT_TOKEN,
  gift_token: value,
});

export const setLocale = (lang) => ({
  type: SET_LOCALE,
  lang,
});
